<template>
  <ul class="sidebar-menu">
    <li class="header">MENU DE NAVEGAÇÃO</li>
    <router-link tag="li" class="pageLink" to="/">
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page">Início</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/operacao/garantias/nova" v-if="this.hasPermission('usuario')">
      <a>
        <i class="fa fa-plus"></i>
        <span class="page">Nova Garantia</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/operacao/garantias/impressao" v-if="this.hasPermission('usuario')">
      <a>
        <i class="fa fa-barcode"></i>
        <span class="page">Impressão de Boletos</span>
      </a>
    </router-link>
       <router-link tag="li" class="pageLink" to="/financeiro/recebimentos" v-if="this.hasPermission('usuario')">
      <a>
        <i class="fa fa-money"></i>
        <span class="page">Recebimentos</span>
      </a>
    </router-link>

     <router-link tag="li" class="pageLink" to="/operacao/antecipacoes" v-if="this.hasPermission('usuario') && this.$store.state.user.empresa.antecipa == 'S'">
      <a>
        <i class="fa fa-reply"></i>
        <span class="page">Antecipações</span>
      </a>
    </router-link>

		<router-link tag="li" class="pageLink" to="/operacao/antecipacoes/simular-venda" v-if="this.hasPermission('usuario') && this.$store.state.user.empresa.simula_venda == 'S'">
      <a>
        <i class="fa fa-list-ul"></i>
        <span class="page">Simular Venda com Taxas</span>
      </a>
    </router-link>

    <li class="treeview"  v-if="this.hasPermission('usuario')">
     <a href="http://chat.credipremium.com.br/chat" target="_blank">
      <i class="fa fa-wechat"></i><span>Chat</span>
    </a>
  </li>

    <li v-if="this.hasPermission('administrador')" class="header">OPERAÇÃO</li>

    <router-link  tag="li" class="pageLink" to="/operacao/garantias" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-exchange"></i>
        <span class="page">Garantias</span>
      </a>
    </router-link>

    <router-link style="cursor:pointer" tag="li" class="pageLink" to="/operacao/remessas" v-if="this.hasPermission('administrador')">
      <a >
        <i class="fa fa-mail-forward"></i>
        <span class="page">Remessas</span>
      </a>
    </router-link>

    <router-link style="cursor:pointer" tag="li" class="pageLink" to="/operacao/retornos" v-if="this.hasPermission('administrador')">
      <a >
        <i class="fa fa-mail-reply"></i>
        <span class="page">Retornos</span>
      </a>
    </router-link>

     <router-link tag="li" class="pageLink" to="/operacao/antecipacoes" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-reply"></i>
        <span class="page">Antecipações</span>
      </a>
    </router-link>

    <li class="header" v-if="this.hasPermission('administrador')">FINANCEIRO</li>
    <router-link tag="li" class="pageLink" to="/financeiro/relatorios/faturamento" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-money"></i>
        <span class="page">Faturamento</span>
      </a>
    </router-link>

    <router-link tag="li" class="pageLink" to="/financeiro/relatorios/fechamento" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-edit"></i>
        <span class="page">Relatório de Fechamento</span>
      </a>
    </router-link>

   <router-link tag="li" class="pageLink" to="/financeiro/boletos" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-barcode"></i>
        <span class="page">Boletos Garantidos</span>
      </a>
    </router-link>

     <router-link tag="li" class="pageLink" to="/financeiro/boletos-avulsos" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-barcode"></i>
        <span class="page">Boletos Avulsos</span>
      </a>
    </router-link>

    <li v-if="this.hasPermission('administrador')" class="header">COBRANÇA</li>

    <router-link  tag="li" class="pageLink" to="/cobranca/inadimplentes" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-exchange"></i>
        <span class="page">Inadimplentes</span>
      </a>
    </router-link>

    <router-link  tag="li" class="pageLink" to="/cobranca/agendamentos" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-exchange"></i>
        <span class="page">Agendamentos</span>
      </a>
    </router-link>

    <router-link  tag="li" class="pageLink" to="/cobranca/acordos" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-exchange"></i>
        <span class="page">Acordos</span>
      </a>
    </router-link>

    <li class="header" v-if="this.hasPermission('administrador')">ADMINISTRAÇÃO</li>

    <router-link tag="li" class="pageLink" to="/administracao/usuarios" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-users"></i>
        <span class="page">Usuários do Sistema</span>
      </a>
    </router-link>

    <router-link tag="li" class="pageLink" to="/administracao/empresas" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-bank"></i>
        <span class="page">Empresas</span>
      </a>
    </router-link>

    <router-link tag="li" class="pageLink" to="/cadastros/empresas" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-user-secret"></i>
        <span class="page">Franqueados</span>
      </a>
    </router-link>

    <router-link tag="li" class="pageLink" to="/administracao/pessoas" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-user"></i>
        <span class="page">Pessoas</span>
      </a>
    </router-link>

    <router-link tag="li" class="pageLink" to="/cadastros/empresas" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-close"></i>
        <span class="page">Inadimplentes</span>
      </a>
    </router-link>

    <router-link tag="li" class="pageLink" to="/cadastros/empresas" v-if="this.hasPermission('administrador')">
      <a>
        <i class="fa fa-warning"></i>
        <span class="page">CPFs Suspeitos</span>
      </a>
    </router-link>
  </ul>
</template>
<script>
export default {
  name: "SidebarMenu",
  data: () => ({}),
  methods: {
    showManutencao() {
      this.$swal({
        type: "warning",
        title: "Funcionalidade em Manutenção!",
        text: "Estamos realizando ajustes nessa funcionalidade e logo mais liberaremos pra você.",
        showConfirmButton: true
      });
    }
  }
};
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?2eaa4f4b